import React from "react";
import { Link, useLocation } from "react-router-dom";
import BrandMark from "../ui/BrandMark";
import { getStoredToken } from "../api/client";

export default function Landing() {
  const location = useLocation();
  const [showIntro, setShowIntro] = React.useState(false);
  const [isExiting, setIsExiting] = React.useState(false);
  const professionalDestination = getStoredToken() ? "/app/build" : `/login?next=${encodeURIComponent("/app/build")}`;

  React.useEffect(() => {
    const params = new URLSearchParams(location.search || "");
    const replay = params.get("intro") === "1";
    const seen = sessionStorage.getItem("landing_intro_seen") === "1";
    if (!replay && seen) return;
    setShowIntro(true);
    const exitTimer = window.setTimeout(() => setIsExiting(true), 1200);
    const doneTimer = window.setTimeout(() => {
      sessionStorage.setItem("landing_intro_seen", "1");
      setShowIntro(false);
      setIsExiting(false);
    }, 1800);
    return () => { window.clearTimeout(exitTimer); window.clearTimeout(doneTimer); };
  }, [location.search]);

  const handleSkip = () => {
    sessionStorage.setItem("landing_intro_seen", "1");
    setShowIntro(false);
    setIsExiting(false);
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-zinc-100">
      {showIntro ? (
        <div className={`absolute inset-0 z-20 flex items-center justify-center bg-slate-950 text-white ${isExiting ? "intro-overlay-exit" : "intro-overlay-enter"}`}>
          <button type="button" className="absolute right-5 top-5 rounded-lg border border-white/20 bg-white/10 px-3 py-1.5 text-sm hover:bg-white/20" onClick={handleSkip}>Skip</button>
          <div className="flex flex-col items-center gap-4">
            <div className="rounded-2xl bg-white/95 px-4 py-3 shadow-[0_0_28px_rgba(255,255,255,0.35)]"><BrandMark size="lg" stacked /></div>
            <p className="text-center text-xs uppercase tracking-[0.18em] text-white/80 sm:text-sm">Created by W.I.S.E Wheeler Insurance Solutions and Expertise</p>
          </div>
        </div>
      ) : null}

      <main className="flex min-h-screen items-center justify-center px-5 py-12">
        <div className="w-full max-w-5xl">
          <div className="mb-10 text-center">
            <BrandMark size="sm" className="mx-auto mb-4" />
            <h1 className="text-3xl font-semibold tracking-tight text-zinc-950 sm:text-5xl">How can Estimation Station help?</h1>
            <p className="mx-auto mt-3 max-w-2xl text-zinc-600">Choose the experience that fits your project.</p>
          </div>
          <div className="grid gap-6 md:grid-cols-2">
            <Link to="/repair-estimate" className="group flex aspect-square items-center justify-center rounded-[2rem] bg-red-700 p-8 text-center text-white shadow-2xl transition duration-200 hover:-translate-y-1 hover:bg-red-600 focus:outline-none focus:ring-4 focus:ring-red-300">
              <span className="max-w-xs text-3xl font-semibold leading-tight sm:text-4xl">Get Repair Estimate</span>
            </Link>
            <Link to={professionalDestination} className="group flex aspect-square items-center justify-center rounded-[2rem] bg-zinc-950 p-8 text-center text-white shadow-2xl transition duration-200 hover:-translate-y-1 hover:bg-black focus:outline-none focus:ring-4 focus:ring-zinc-400">
              <span className="max-w-xs text-3xl font-semibold leading-tight sm:text-4xl">For Restoration Professionals</span>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
